import React, { ReactNode, useState } from 'react';
import cx from 'classnames';
import { Collapse } from 'react-collapse';
import { Icon } from '../Icons';

interface Props {
  children?: ReactNode;
  collapse?: ReactNode;
  title?: string;
  className?: string;
  titleClass?: string;
}
export const FilterWrapper = ({ children, collapse, title, className, titleClass }: Props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const renderCollapse = () => {
    const icon = collapseOpen ? 'SvgIconArrowUpBold' : 'SvgIconArrowDownBold';
    const controlCollapse = () => {
      setCollapseOpen(!collapseOpen);
    };
    return (
      <>
        <Collapse isOpened={collapseOpen}>{collapse}</Collapse>
        <button
          className="pa0 ml4 abbey bn f14 lh-copy fw7 bg-transparent"
          onClick={controlCollapse}
        >
          Mais <Icon className="pt4" name={icon} height={11} width={11} />
        </button>
      </>
    );
  };
  const classTitle = cx(titleClass, 'ma0 f16 fw7 abbey lh-title pl4');
  return (
    <div className={className}>
      <p className={classTitle}>{title}</p>
      {children}
      {collapse && renderCollapse()}
    </div>
  );
};
